const RangedQuestionFields = function () {
  var $ctrl = this;

  $ctrl.$onInit = function () {
    setValuesFromQuestion();
  };

  $ctrl.editRangeInfo = function () {
    $ctrl.editingRangeInfo = true;
  };

  $ctrl.save = function () {
    $ctrl.editingRangeInfo = false;

    $ctrl.onChange({
      newRangeInfo: {
        lower_bound: $ctrl.lowerBound,
        upper_bound: $ctrl.upperBound,
        lower_label: $ctrl.lowerLabel,
        upper_label: $ctrl.upperLabel
      }
    });
  };

  $ctrl.cancel = function () {
    setValuesFromQuestion();
    $ctrl.editingRangeInfo = false;
  };

  $ctrl.changeLowerBound = function () {
    if ($ctrl.lowerBound >= $ctrl.upperBound) {
      $ctrl.upperBound = $ctrl.lowerBound + 1;
    }
  };

  $ctrl.changeUpperBound = function () {
    if ($ctrl.lowerBound >= $ctrl.upperBound) {
      $ctrl.lowerBound = $ctrl.upperBound - 1;
    }
  };

  function setValuesFromQuestion() {
    $ctrl.lowerBound = $ctrl.question.range_info.lower_bound;
    $ctrl.upperBound = $ctrl.question.range_info.upper_bound;
    $ctrl.lowerLabel = $ctrl.question.range_info.lower_label;
    $ctrl.upperLabel = $ctrl.question.range_info.upper_label;
  }

};

export default {
  name: 'rangedQuestionFields',
  obj: {
    controller: RangedQuestionFields,
    templateUrl: 'components/ranged_question_fields.html',
    bindings: {
      question: '<',
      onChange: '&'
    }
  },
  deps: []
};